import React, {useEffect, useState} from 'react';
import List from '../components/List';
import '../styles/pages/nfc-management.css';
import {apiRequest} from "../utils/api";
import {Modal} from "@mantine/core";
import Button from "../components/Button";


const NFCManagement = () => {
    const [userId, setUserId] = useState(null);
    const userHeaders = ['일시', '이름', '상태', '연락처', '보기'];
    const userDetailHeaders = ['NO', '태그NO', '사업장명', '주소' , '삭제'];
    const isMobile = window.innerWidth <= 768;
    const userListColumnWidths = isMobile
        ? ['100px', '80px', '50px', '120px', '40px']
        : ['25%', '20%', '20%', '25%', '10%'];

    const nfcListColumnWidths = isMobile
        ? ['80px', '80px', '140px', '200px','50px']
        : ['10%', '20%', '20%', '40%','10%'];
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [storeModalOpen, setStoreModalOpen] = useState(false);
    const [unassignedStores, setUnassignedStores] = useState([]);
    const [selectedStores, setSelectedStores] = useState([]);
    const [userDetailData, setUserDetailData] = useState([]);

    const [manager, setManager] = useState('');

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleUserClick = (user) => {
        setManager(user.NAME);
        setUserId(user.ID);
        setSelectedUser(user);
        handleGetNFC(user.ID);
    };
    const getUserDetailData = () => userDetailData;

    const fetchUsers = async () => {
        try {
            const res = await apiRequest('/users', 'POST');

            const refinedData = res.map(user => {
                return {
                    REG_DTM: user.REG_DTM?.substring(0, 10),
                    USER: <span style={{textDecoration: 'underline', fontWeight: '600'}}
                                onClick={() => handleUserNameClick({...user, _fullUser: user})}
                    >{user.NAME}</span>,
                    STATUS: user.STATUS === 'Y' ? '정상' : '제한',
                    PHONE: user.PHONE,
                    DETAIL: <Button style={{background: '#F9F9F9', color: '#3d3d3d', padding: '5px 20px'}}
                                    onClick={() => handleUserClick(user)}>보기</Button>,
                    _fullUser: user,
                };
            });
            setUserList(refinedData);
        } catch (err) {
            console.error("회원 목록 불러오기 실패", err);
        }
    };

    const handleOpenStoreModal = async () => {
        try {
            const res = await apiRequest('/selectNFCStore', 'GET');
            const unassigned = res.filter(store => !store.USER_ID);
            setUnassignedStores(unassigned);
            setStoreModalOpen(true);
        } catch (err) {
            console.error("미지정 스토어 조회 실패", err);
        }
    };

    const handleCloseStoreModal = () => {
        setStoreModalOpen(false);
        setSelectedStores([]);
        setUnassignedStores([]);
    };

    const handleAssignStoresToUser = async () => {

        if (!userId) {
            alert("먼저 회원을 선택해주세요.");
            return;
        }
        console.log("selectedStores",selectedStores);

        try {
            await apiRequest('/assignUserToStores', 'POST', {
                userId,
                storeIds: selectedStores
            });
            alert('매칭 완료');
            setStoreModalOpen(false);
            setSelectedStores([]);
            fetchUsers(); // or 재조회
        } catch (err) {
            console.error("스토어 매칭 실패", err);
            alert("매칭 실패");
        }
    };

    const handleGetNFC = async (id) => {
        try {
            const data = await apiRequest(`/nfcList?userId=${id}`, 'GET');
            setUserDetailData(data); // ✅ 리스트에 바로 넣기

            const refinedData2 = data.map(store => {
                return {
                    ID: store.ID,
                    TAGNUM: store.TAGNUM,
                    NAME: store.NAME,
                    ADDR: store.ADDR,
                    DETAIL: <Button style={{background: '#F9F9F9', color: '#3d3d3d', padding: '5px 20px'}}
                                    onClick={() => handleDeleteStore(store)}>삭제</Button>,
                };
            });
            setUserDetailData(refinedData2);
        } catch (err) {
            console.error("NFC 스토어 조회 실패", err);
        }
    };

    const handleDeleteStore = async (store) => {

        const store_id = store.ID
        const user_id = store.USER_ID
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm(`정말로 해당 사업장과 회원의 연결을 해제하시겠습니까?\n(사업장 정보는 삭제되지 않습니다)`);

        if (!confirmed) return;

        try {
            const res = await apiRequest('/deleteUserStore', 'POST', {ID: store_id, USER_ID:user_id});

            if (res.success) {
                alert("삭제 완료");
                fetchUsers();
                handleGetNFC();
            } else {
                alert("삭제 실패");
            }
        } catch (err) {
            console.error("삭제 실패", err);
            alert("에러 발생");
        }
    };

    const handleUserNameClick = (item) => {
        setSelectedUser(item._fullUser);
        setIsModalOpen(true);
    };

    return (
        <div className="page-content">
            <div className="left-section">
                <p className="title-text gmarket-font">회원목록</p>
                <div className='small-margin-section'/>
                <div className="list-wrapper user-list-wrapper">
                    <List
                        headers={userHeaders}
                        data={userList}
                        showCheckbox={false}
                        columnWidths={userListColumnWidths}
                    />
                </div>
            </div>

            <div className="right-section">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <p className="title-text gmarket-font">{manager} NFC목록 </p>
                    <Button onClick={handleOpenStoreModal} style={{width: '80px', height: '45px'}}>추가</Button>
                </div>

                <div className='small-margin-section'/>
                <div className="list-wrapper nfc-list-wrapper">
                    {userId ? (
                        <List
                            headers={userDetailHeaders}
                            data={getUserDetailData()}
                            showCheckbox={false}
                            columnWidths={nfcListColumnWidths}
                        />
                    ) : (
                        <div className="empty-message gmarket-font">
                            회원을 선택하면 상세정보가 표시됩니다.
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen && selectedUser && (
                <Modal
                    opened={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    title={<span
                        className="gmarket-font"
                        style={{fontSize: '20px', fontWeight: 600}}>{selectedUser?.NAME} 님 상세 정보</span>}
                    centered
                    size="lg"
                    zIndex={1000}
                >
                    {selectedUser && (
                        <div className="gmarket-font" style={{lineHeight: 2, fontSize: '16px'}}>
                            <div className="modal-info-row">
                                <span className="modal-info-label">이름</span>
                                <span className="modal-info-value">{selectedUser.NAME}</span>
                            </div>
                            <div className="modal-info-row">
                                <span className="modal-info-label">연락처</span>
                                <span className="modal-info-value">{selectedUser.PHONE}</span>
                            </div>
                            <div className="modal-info-row">
                                <span className="modal-info-label">주소</span>
                                <span
                                    className="modal-info-value">{selectedUser.ADDR + ' ' + selectedUser.DETAIL_ADDR}</span>
                            </div>
                            <div className="modal-info-row">
                                <span className="modal-info-label">상태</span>
                                <span className="modal-info-value">{selectedUser.STATUS === 'Y' ? '정상' : '제한'}</span>
                            </div>
                            <div className="modal-info-row">
                                <span className="modal-info-label">등급</span>
                                <span className="modal-info-value">{selectedUser.STATE === 'U' ? '일반회원' : '관리자'}</span>
                            </div>
                        </div>
                    )}
                </Modal>
            )}
            {storeModalOpen && (
                <Modal
                    opened={storeModalOpen}
                    onClose={handleCloseStoreModal}
                    centered
                    size="xl"
                    zIndex={1000}
                >
                    <div className="store-modal-container">
                        <h2 className="gmarket-font store-modal-title">사업장 선택</h2>

                        <div className="store-table-wrapper">
                            <table className="store-table">
                                <thead>
                                <tr className="store-table-header">
                                    <th className="th-select">선택</th>
                                    <th className="th-tagnum">태그NO</th>
                                    <th className="th-name">현장명</th>
                                    <th className="th-addr">주소</th>
                                </tr>
                                </thead>
                                <tbody>
                                {unassignedStores.map((store) => (
                                    <tr key={store.ID} className="store-table-row">
                                        <td className="td-select">
                                            <div
                                                className={`patrol-list-checkbox ${selectedStores.includes(store.ID) ? 'checked' : ''}`}
                                                onClick={() => {
                                                    if (selectedStores.includes(store.ID)) {
                                                        setSelectedStores(prev => prev.filter(id => id !== store.ID));
                                                    } else {
                                                        setSelectedStores(prev => [...prev, store.ID]);
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className="td-tagnum">{store.TAGNUM}</td>
                                        <td className="td-name">{store.NAME}</td>
                                        <td className="td-addr">{store.ADDR + ' ' + store.DETAIL_ADDR}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="store-modal-footer">
                        <Button className="store-modal-save-btn" onClick={handleAssignStoresToUser}>저장</Button>
                    </div>
                </Modal>
            )}

        </div>
    );
};

export default NFCManagement;